/* eslint-disable @typescript-eslint/no-use-before-define */
import React, {useState, useEffect} from 'react'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import {KTSVG} from '../../../_metronic/helpers'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import {useTranslation, initReactI18next} from 'react-i18next'
import {
  createScheduleOrder,
  getScheduleOrder,
  editSchedulle,
  deleteSchedule,
} from '../../../api/modules/order'
import axios from 'axios'
import swal from 'sweetalert'
import CurrencyInput from 'react-currency-input-field'
import i18next from 'i18next'
import {Spinner} from 'react-bootstrap'

function AddRemoveJadwal({id, is_amendment, isDisable = false}) {
  const [listJadwal, setListJadwal] = useState([])
  const [tempMinggu, setTempMinggu] = useState(0)
  const [tempBulan, setTempBulan] = useState(0)
  const [tempTahun, setTempTahun] = useState(0)
  const [tempTon, setTempTon] = useState(0)
  const [tempTanggal, setTempTanggal] = useState(0)
  const [allJadwal, setAllJadwal] = useState([])
  const [taking, setTaking] = useState(0)
  const [btnLoading, setBtnLoading] = useState(false)
  const [daysInMonth, setDaysInMonth] = useState(0)

  const [editedIndex, setEditedIndex] = useState()

  const [inputFields, setInputFields] = useState([
    {
      education_name: '',
      from_date: '',
      till_date: '',
      department: '',
      qualification: '',
      ijazah: '',
    },
  ])

  const addInputField = () => {
    // seti(i+1);
    // const tempJadwal = listJadwal
    // const tempArray = {
    //     sort : i,
    //     week : tempMinggu,
    //     month : tempBulan,
    //     year : tempTahun,
    //     tonnage : tempTon
    // }
    // tempJadwal.push(tempArray)
    // setListJadwal(tempJadwal);

    setInputFields([
      ...inputFields,
      {
        education_name: '',
        from_date: '',
        till_date: '',
        department: '',
        qualification: '',
        ijazah: '',
      },
    ])
  }

  const [listYear, setListYear] = useState([])

  const bulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ]

  const clearStateJadwal = () => {
    setTempMinggu(0)
    setTempBulan(0)
    setTempTahun(0)
    setTempTon(0)
    setEditedIndex()
    const minggu = document.getElementById('minggu')
    minggu.value = ''
    const bulan = document.getElementById('bulan')
    bulan.selectedIndex = 0
    const tahun = document.getElementById('tahun')
    tahun.selectedIndex = 0
    const ton = document.getElementById('ton')
    ton.value = ''
    const input5 = document.getElementById('jadwaltanggal')
    if (input5 != null) input5.selectedIndex = 0
  }

  const sendJadwal = async () => {
    // console.log(listJadwal)
    setBtnLoading(true)
    await createScheduleOrder(
      id,
      {
        sort: taking,
        date: tempTanggal,
        month: tempBulan,
        year: tempTahun,
        tonnage: tempTon,
      },
      is_amendment
    )
      .then((response) => {
        clearStateJadwal()
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        getJadwal()
        swal({
          title: `${t('jadwalBerhasilDimasukkan')}`,
          icon: 'success',
        })
      })
      .catch((error) => {
        if (error)
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const {t} = useTranslation()

  const getJadwal = async () => {
    setBtnLoading(true)
    await getScheduleOrder(id, is_amendment)
      .then((response) => {
        setAllJadwal(response.data.data.schedules)
        let temp = response.data.data.schedules
        setTaking(temp.length + 1)
      })
      .catch((error) => {
        // swal({
        //   title: error.response.data,
        //   icon: 'error',
        // })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }
  const handleYear = () => {
    let year = []
    const aYearFromNow = new Date()
    year.push(new Date(aYearFromNow.setFullYear(aYearFromNow.getFullYear())).getFullYear())
    for (let i = 0; i < 2; i++) {
      year.push(new Date(aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1)).getFullYear())
    }
    setListYear(year)
    setDaysInMonth(getDaysInMonth(aYearFromNow.getFullYear(), aYearFromNow.getMonth() + 1))
  }
  function getDaysInMonth(year, month) {
    return new Date(year, month, 0).getDate()
  }

  function loopTanggal(jumlah) {
    var indents = []
    for (let i = 0; i < jumlah; i++) {
      indents.push(<option value={i + 1}>{i + 1}</option>)
    }
    return indents
  }

  useEffect(() => {
    if (tempTahun != 0 && tempBulan != 0) setDaysInMonth(getDaysInMonth(tempTahun, tempBulan))
  }, [tempTahun, tempBulan])

  useEffect(() => {
    getJadwal()
    handleYear()
  }, [])

  const rubahSchedule = async (ids, taking, date, month, year) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (accept) => {
      if (accept) {
        setBtnLoading(true)
        await editSchedulle(ids, {
          sort: taking,
          date: date,
          month: month,
          year: year,
          tonnage: tempTon,
        })
          .then(async (res) => {
            await getScheduleOrder(id, is_amendment)
              .then((response) => {
                setAllJadwal(response.data.data.schedules)
                let temp = response.data.data.schedules

                setTaking(temp.length + 1)
                swal({
                  title: `${t(res.data.message)}`,
                  icon: 'success',
                })
              })
              .catch((error) => {
                swal({
                  title: error.response.data,
                  icon: 'error',
                })
              })
              .finally(() => {
                setBtnLoading(false)
              })
            // getJadwal()
            setBtnLoading(false)
            setEditedIndex()
          })
          .catch((error) => {
            if (error)
              swal({
                title: `${t(error.response.data.message)}`,
                icon: 'error',
              })
            setBtnLoading(false)
          })
          .finally(() => {
            setBtnLoading(false)
          })
      } else return setEditedIndex()
    })
  }

  const hapusSchedule = async (id) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (accept) => {
      if (accept) {
        setBtnLoading(true)
        await deleteSchedule(id)
          .then((res) => {
            swal({
              title: `${t(res.data.message)}`,
              icon: 'success',
            })
            getJadwal()
            setBtnLoading(false)
            setEditedIndex()
          })
          .catch((error) => {
            if (error)
              swal({
                title: `${t(error.response.data.message)}`,
                icon: 'error',
              })
            setBtnLoading(false)
          })
          .finally(() => {
            setBtnLoading(false)
          })
      } else return setEditedIndex()
    })
  }

  const [language, setLanguage] = useState()
  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div>
      {sessionStorage.getItem('sales') != 'true' && (
        <>
          <div className='table-responsive bdr mt-1'>
            {sessionStorage.getItem('isCustomer') == 'true' ? (
              <table className='table-border w-100'>
                <thead>
                  <tr className='d-flex'>
                    {/* <th style={{ width: '60px' }} className="text-center">{t('order-aksi')}</th> */}
                    <th style={{width: '165.5px'}} className='text-center'>
                      {t('order-pengambilan')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-tanggal')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-minggu')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-bulan')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-tahun')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-tonase')}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <div>
                    {inputFields.map((data, index) => {
                      return (
                        <tr key={index} className='d-flex'>
                          {/* <td style={{ width: '60px' }} className="text-center"><button className="btn btn-danger" onClick={() => removeInputFields(index + 1)}>x</button></td> */}
                          <td style={{width: '165.5px'}} className='text-center'>
                            <p className='mt-3'>{taking}</p>
                          </td>
                          <td
                            style={{width: '185.5px'}}
                            className='text-center d-flex justify-content-center'
                          >
                            <Form.Select
                              aria-label='Default select example'
                              id='jadwaltanggal'
                              style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                              onChange={(e: any) => setTempTanggal(parseInt(e.target.value))}
                            >
                              <option selected value={0} disabled hidden>
                                {t('Pilih-Tanggal')}
                              </option>
                              {daysInMonth != 0 ? loopTanggal(daysInMonth) : ''}
                            </Form.Select>
                          </td>
                          <td
                            style={{width: '185.5px'}}
                            className='text-center d-flex justify-content-center'
                          >
                            <Form.Control
                              aria-label='Default select example'
                              id='minggu'
                              placeholder={t('order-minggu')}
                              style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                              value={tempTanggal == 0 ? '' : t('Week') + Math.ceil(tempTanggal / 7)}
                            />
                          </td>
                          <td
                            style={{width: '185.5px'}}
                            className='text-center d-flex justify-content-center'
                          >
                            <Form.Select
                              aria-label='Default select example'
                              style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                              id='bulan'
                              onChange={(e: any) => parseInt(setTempBulan(e.target.value))}
                            >
                              <option selected disabled>
                                {t('Pilih-Month')}
                              </option>
                              <option value='1'>{t('Januari')}</option>
                              <option value='2'>{t('Februari')}</option>
                              <option value='3'>{t('Maret')}</option>
                              <option value='4'>{t('April')}</option>
                              <option value='5'>{t('Mei')}</option>
                              <option value='6'>{t('Juni')}</option>
                              <option value='7'>{t('Juli')}</option>
                              <option value='8'>{t('Agustus')}</option>
                              <option value='9'>{t('September')}</option>
                              <option value='10'>{t('Oktober')}</option>
                              <option value='11'>{t('November')}</option>
                              <option value='12'>{t('Desember')}</option>
                            </Form.Select>
                          </td>
                          <td
                            style={{width: '185.5px'}}
                            className='text-center d-flex justify-content-center'
                          >
                            <Form.Select
                              aria-label='Default select example'
                              style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                              id='tahun'
                              onChange={(e: any) => parseInt(setTempTahun(e.target.value))}
                            >
                              <option selected disabled>
                                {t('Pilih-Year')}
                              </option>
                              {listYear.map((data) => {
                                return (
                                  <option key={data} value={data}>
                                    {data}
                                  </option>
                                )
                              })}
                              {/* <option value='2023'>2023</option>
                              <option value='2024'>2024</option>
                              <option value='2025'>2025</option>
                              <option value='2026'>2026</option>
                              <option value='2027'>2027</option>
                              <option value='2028'>2028</option>
                              <option value='2029'>2029</option>
                              <option value='2030'>2030</option>
                              <option value='2031'>2031</option> */}
                            </Form.Select>
                          </td>
                          <td
                            style={{width: '185.5px'}}
                            className='text-center d-flex justify-content-center'
                          >
                            <CurrencyInput
                              id='ton'
                              key={tempTahun}
                              placeholder={t('order-tonase')}
                              className='form-control form-control-sm'
                              style={{width: '90%'}}
                              decimalSeparator={language === 'en' ? '.' : ','}
                              groupSeparator={language === 'en' ? ',' : '.'}
                              onValueChange={(value: any) => {
                                setTempTon(parseFloat(value?.replace(/,/g, '.')))
                              }}
                              decimalsLimit={3}
                            />
                          </td>
                        </tr>
                      )
                    })}
                  </div>
                </tbody>
                {/* <div className="d-flex justify-content-end">
                        <button className="btn btn-success my-3 me-3" onClick={addInputField}>
                        {t('order-tambah')}
                        </button>
                    </div> */}
                <div className='d-flex justify-content-end mt-5'>
                  <Button variant='primary' onClick={() => sendJadwal()} disabled={btnLoading}>
                    {btnLoading ? (
                      <Spinner animation='border' variant='light' size='sm' />
                    ) : (
                      t('order-kirim')
                    )}
                  </Button>
                </div>
              </table>
            ) : (
              ''
            )}
          </div>
        </>
      )}
      {allJadwal.length < 1 ? (
        <div className='text-center fs-4 fw-semibold'>{t('no schedule')}</div>
      ) : (
        <div className='table-responsive bdr mt-2'>
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            <thead className='border-bottom'>
              <tr className='fw-bold d-flex'>
                {sessionStorage.getItem('isCustomer') == 'true' ? (
                  <>
                    <th style={{width: '156.3px'}} className='text-center'>
                      {t('order-pengambilan')}
                    </th>
                    <th style={{width: '156.3px'}} className='text-center'>
                      {t('order-tanggal')}
                    </th>
                    <th style={{width: '156.3px'}} className='text-center'>
                      {t('order-minggu')}
                    </th>
                    <th style={{width: '156.3px'}} className='text-center'>
                      {t('order-bulan')}
                    </th>
                    <th style={{width: '156.3px'}} className='text-center'>
                      {t('order-tahun')}
                    </th>
                    <th style={{width: '156.3px'}} className='text-center'>
                      {t('order-tonase')}
                    </th>
                    <th style={{width: '156.3px'}} className='text-center'>
                      {t('order-aksi')}
                    </th>
                  </>
                ) : (
                  <>
                    <th style={{width: '165.5px'}} className='text-center'>
                      {t('order-pengambilan')}
                    </th>
                    <th style={{width: '182.5px'}} className='text-center'>
                      {t('order-tanggal')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-minggu')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-bulan')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-tahun')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-tonase')}
                    </th>
                  </>
                )}
              </tr>
            </thead>
            {allJadwal.map((data, _index) => (
              <tbody key={_index}>
                {sessionStorage.getItem('isCustomer') == 'true' ? (
                  <>
                    <tr className='d-flex'>
                      <td style={{width: '156.3px'}} className='text-center'>
                        <label className='mt-3'>{_index + 1}</label>
                      </td>
                      <td style={{width: '156.3px'}} className='text-center'>
                        <label className='mt-3'>{data.date}</label>
                      </td>
                      <td style={{width: '156.3px'}} className='text-center'>
                        <label className='mt-3'>
                          {t('Week')} {Math.ceil(data.date / 7)}
                        </label>
                      </td>
                      <td style={{width: '156.3px'}} className='text-center'>
                        <label className='mt-3'>{t(bulan[data.month - 1])}</label>
                      </td>
                      <td style={{width: '156.3px'}} className='text-center'>
                        <label className='mt-3'>{data.year}</label>
                      </td>
                      <td style={{width: '156.3px'}} className='text-center'>
                        {editedIndex == _index ? (
                          <CurrencyInput
                            id='ton'
                            placeholder={t('order-tonase')}
                            className='form-control form-control-sm'
                            defaultValue={data.tonnage}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setTempTon(parseFloat(value?.replace(/,/g, '.')))
                            }}
                            decimalsLimit={3}
                          />
                        ) : (
                          <label className='mt-3'>
                            {(i18next.language === 'en'
                              ? data.tonnage.toLocaleString('en', {maximumFractionDigits: 4})
                              : data.tonnage.toLocaleString('id', {maximumFractionDigits: 4})) +
                              ' ' +
                              'Ton'}
                          </label>
                        )}
                      </td>
                      {sessionStorage.getItem('isCustomer') == 'true' && (
                        <td style={{width: '156.3px'}} className='text-center'>
                          {editedIndex == _index ? (
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('Approve')}
                              onClick={() =>
                                rubahSchedule(data.id, _index, data.date, data.month, data.year)
                              }
                            >
                              <KTSVG
                                path='/media/icons/duotune/check-square.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          ) : (
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              disabled={isDisable}
                              title={t('ubah')}
                              onClick={() => {
                                setEditedIndex(_index)
                                setTempTon(data.tonnage)
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/pencil-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          )}

                          <button
                            onClick={() => hapusSchedule(data.id)}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            disabled={isDisable}
                            title={t('Hapus')}
                          >
                            <KTSVG
                              path='/media/icons/duotune/trash-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        </td>
                      )}
                    </tr>
                  </>
                ) : (
                  <>
                    <tr className='d-flex'>
                      <td style={{width: '165.5px'}} className='text-center'>
                        {_index + 1}
                      </td>
                      <td style={{width: '182.5px'}} className='text-center'>
                        {data.date}
                      </td>
                      <td style={{width: '185.5px'}} className='text-center'>
                        {t('Week')} {Math.ceil(data.date / 7)}
                      </td>
                      <td style={{width: '185.5px'}} className='text-center'>
                        {t(bulan[data.month - 1])}
                      </td>
                      <td style={{width: '185.5px'}} className='text-center'>
                        {data.year}
                      </td>
                      <td style={{width: '190px'}} className='text-center'>
                        <label>
                          {(i18next.language === 'en'
                            ? data.tonnage.toLocaleString('en', {maximumFractionDigits: 4})
                            : data.tonnage.toLocaleString('id', {maximumFractionDigits: 4})) +
                            ' ' +
                            'Ton'}
                        </label>
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            ))}
          </table>
        </div>
      )}

      {/* <div className="d-flex justify-content-end mt-5">
                <Button variant="primary" onClick={() => sendJadwal()}>
                    {t('order-kirim')}
                </Button>
            </div> */}
    </div>
  )
}
export default AddRemoveJadwal
